import { jsx as _jsx } from "react/jsx-runtime";
import { cx } from "@emotion/css";
import { classCombinerFromPrefix, renderIdentifierGeneric } from "../RenderIdentifier";
import BusinessDirectoryOptoutStyles from "./BusinessDirectoryOptoutStyles.module.scss";
const styles = BusinessDirectoryOptoutStyles;
const classCombiner = classCombinerFromPrefix("a135ef82405814cf");
const InternalLinkComponent = (properties) => (_jsx("a", Object.assign({ className: cx(classCombiner(styles, "link")), href: properties.href, title: properties.label }, { children: properties.label })));
const ExternalLinkComponent = (properties) => (_jsx("a", Object.assign({ className: cx(classCombiner(styles, "link")), href: properties.href, rel: "noreferrer", target: "_blank", title: properties.label }, { children: properties.label })));
const ContactLinkComponent = (parameters) => (parameters.newWindow ? _jsx(ExternalLinkComponent, Object.assign({}, parameters)) : _jsx(InternalLinkComponent, Object.assign({}, parameters)));
const replaceJsx = (string, replacement) => {
    const result = [];
    const keys = window.Object.keys(replacement);
    const getRegExp = () => {
        const regexp = [];
        for (const key of keys) {
            regexp.push(`{${key}}`);
        }
        return new RegExp(regexp.join("|"));
    };
    const regExp = getRegExp();
    string.split(regExp).forEach((st, nu) => result.push(st, replacement[keys[nu]]));
    return result;
};
const BusinessDirectoryOptoutComponent = (props) => _jsx("div", Object.assign({ className: cx(classCombiner(styles, "title")) }, { children: replaceJsx(props.headingText, {
        "companyName": props.companyName,
        "contactLink": _jsx(ContactLinkComponent, { cssClass: props.linkClasses, href: props.linkHref, label: props.linkText, newWindow: props.linkNewWindow }),
    }) }));
const businessDirectoryOptout = (renderableData) => renderIdentifierGeneric(BusinessDirectoryOptoutComponent, renderableData);
export { businessDirectoryOptout };
